<label class="text-center text-tertiary fw-semibold w-100">
	{{ tituloGrafico }}
</label>
<seira-card-info aditionalClasses="my-3" [texto]="descricaoRelatorio" />

<label
	*ngIf="mensagemDataMinima"
	id="intervalo-dados-disponiveis"
	class="text-center w-100 mb-2">
	{{ mensagemDataMinima }}
</label>

<div
	*ngIf="loading; else grafico"
	class="d-flex justify-content-center align-items-center w-100 h-50"
	style="min-height: 500px">
	<seira-loading [pageCentered]="false"></seira-loading>
</div>

<ng-template #grafico>
	<seira-high-stock
		classChart="highcharts-light"
		[options]="chartOptions"
		(chartInstance)="onChartCreated($event)" />
</ng-template>
